import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';

import DashModalV2 from '../DashModalV2';
import { DateFormatMAS90 } from '../../functions/dateFormat';

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        showModal1: false,
        Detail: [],
        Title: '',
        Total: 0,
        TotalQuantity: 0
    }

    handleModalOpen = (modal, Detail, Title, Sales, Total) => {
        const arr = Array.isArray(Detail) ? Detail : []
        this.setState({ [modal]: true, Detail: arr.slice(0, 500), Title: Title, Total: Sales, TotalQuantity: Total })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false, Detail: [], Title: '', Total: 0 })
    }

    routeColor(route) {
        const r = (route || '').toLowerCase();
        if (r.includes('warehouse'))   return 'route-blue';
        if (r.includes('supermarket')) return 'route-green';
        if (r.includes('pallet'))      return 'route-purple';
        if (r.includes('distributor')) return 'route-amber';
        if (r.includes('nebraska'))    return 'route-teal';
        if (r.includes('atlanta') || r.includes('georgia'))  return 'route-cyan';
        if (r.includes('alabama') || r.includes('birmingham') || r.includes('tuscaloosa') || r.includes('montgomery')) return 'route-orange';
        return 'route-gray';
    }

    render() {
        return (
            <>
            <div className='card'>
                <div className='card-body'>
                    <div className='row '>
                        <div className='col-sm-6'>
                            <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                        </div>
                        <div className='col-sm-12'>
                            <div className='pb-3' />
                            <div className="tableFixHeadSmall ">
                                <table className='table table-clean'>
                                    <thead>
                                        <tr>
                                            <th>Route</th>
                                            <th>Customer No</th>
                                            <th>Customer Name</th>
                                            <th># Of Sales</th>
                                            <th>Total Of Sales</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.data || []).slice(0, 400).map((order, o) => (
                                            <tr onClick={() => this.handleModalOpen('showModal1', order.Detail, order.CustomerName, order.Total, order.TotalNo)} key={o} className={this.routeColor(order.Route)}>
                                                <td>{order.Route}</td>
                                                <td>{order.CustomerNo}</td>
                                                <td>{order.CustomerName}</td>
                                                <td className='text-center'>{order.TotalNo}</td>
                                                <td className='text-center'>${NumberFormat(pricesFormat(order.Total))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DashModalV2
                title={'Customer: ' + this.state.Title}
                subtitle={`${this.state.TotalQuantity} invoices · $${NumberFormat(pricesFormat(this.state.Total))} total`}
                show={this.state.showModal1}
                onClose={() => this.handleModalClose('showModal1')}
            >
                <div className="tableFixHeadSmall">
                    <table className='table table-clean'>
                        <thead>
                            <tr>
                                <th>Invoice No</th>
                                <th>Route</th>
                                <th>Date</th>
                                <th className='text-end'>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.Detail.map((order, o) => (
                                <tr key={o}>
                                    <td>{order.InvoiceNo}</td>
                                    <td>{order.UDF_RUTA}</td>
                                    <td className='text-center'>{DateFormatMAS90(order.InvoiceDate)}</td>
                                    <td className='text-end'>${NumberFormat(pricesFormat(order.NonTaxableSalesAmt))}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot className='tfoot'>
                            <tr>
                                <td className='textTableSize fw-bold'>Totals</td>
                                <td></td>
                                <td className='textTableSize text-center fw-bold'>{this.state.TotalQuantity} inv</td>
                                <td className='textTableSize text-end fw-bold'>${NumberFormat(pricesFormat(this.state.Total))}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </DashModalV2>
            </>
        )
    }
}
